/* PRISKEL — the bag. Renders from /cart.js, opens on add-to-bag, hands checkout to Fastrr. */
(function () {
  if (window.__pkCart) return;
  window.__pkCart = 1;
  var dlg = document.getElementById('pk-cart');
  if (!dlg) return;
  var PK = window.PK || {};
  var body = dlg.querySelector('[data-pk-c-body]');
  var tierEl = dlg.querySelector('[data-pk-c-tier]');
  var foot = dlg.querySelector('[data-pk-c-foot]');
  var sumEl = dlg.querySelector('[data-pk-c-sum]');
  var goLbl = dlg.querySelector('[data-pk-c-go]');
  var nEl = dlg.querySelector('[data-pk-c-n]');
  var T2 = +dlg.getAttribute('data-t2') || 10, T3 = +dlg.getAttribute('data-t3') || 15;
  var CODE = dlg.getAttribute('data-code') || '';
  var WCODE = dlg.getAttribute('data-welcome') || '';
  var WON = dlg.getAttribute('data-welcome-on') === '1';
  var WTX = dlg.getAttribute('data-welcome-tx') || '';
  var UPSELL = dlg.getAttribute('data-upsell') || '';
  var EMPTY = dlg.getAttribute('data-empty') || 'best-sellers-jewellery-india';
  var EMPTY_URL = dlg.getAttribute('data-empty-url') || '/collections/all';
  var cart = null, busy = false, recoCache = {}, noteTimer = null;
  var cmp = {}, cmpDone = {};
  var youEl = document.createElement('p');
  youEl.className = 'pk-cart__you'; youEl.hidden = true; youEl.setAttribute('aria-live', 'polite');
  var fineEl = foot ? foot.querySelector('.pk-cart__fine') : null;
  var FINE = fineEl ? fineEl.textContent.trim() : '';
  if (fineEl) fineEl.remove();
  var origFetch = window.fetch.bind(window);

  function money(p) { return '₹' + Math.round(p / 100).toLocaleString('en-IN'); }
  function inr(v) { var n = parseFloat(v); return isFinite(n) ? '₹' + Math.round(n).toLocaleString('en-IN') : ''; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function sized(u, w) { if (!u) return ''; return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  function short(t) { return String(t || '').replace(/ for Women$/i, ''); }
  function json(url, opts) { return origFetch(url, Object.assign({ headers: { 'Content-Type': 'application/json', Accept: 'application/json' } }, opts || {})).then(function (r) { if (!r.ok) throw r; return r.json(); }); }

  /* MRP (compare-at) per variant, read from the product JSON and cached */
  function loadCmp(c) {
    var need = [];
    (c && c.items || []).forEach(function (it) { if (!cmpDone[it.handle] && need.indexOf(it.handle) < 0) need.push(it.handle); });
    if (!need.length) return Promise.resolve(c);
    var all = Promise.all(need.map(function (h) {
      return json('/products/' + encodeURIComponent(h) + '.js').then(function (p) {
        (p.variants || []).forEach(function (v) { if (v.compare_at_price) cmp[v.id] = +v.compare_at_price; });
        cmpDone[h] = 1;
      }).catch(function () { cmpDone[h] = 1; });
    }));
    return Promise.race([all, new Promise(function (r) { setTimeout(r, 1800); })]).then(function () { return c; });
  }
  function mrpOf(it) {
    var u = cmp[it.variant_id] || 0;
    return u > it.original_price ? u * it.quantity : it.original_line_price;
  }

  function pctFor(n) { return n >= 3 ? T3 : n === 2 ? T2 : 0; }

  /* ------------------------------- rendering ------------------------------- */
  function renderTier(n, sub) {
    if (!n) { tierEl.hidden = true; return; }
    var pct = pctFor(n), msg;
    if (n >= 3) msg = '<b>You’re saving ' + T3 + '%.</b> Our best Stack &amp; Save price.';
    else if (n === 2) msg = '<b>You’re saving ' + T2 + '%.</b> Add 1 more piece for ' + T3 + '% off.';
    else msg = 'Add 1 more piece and save <b>' + T2 + '%</b> on both.';
    var fill = n >= 3 ? 100 : n === 2 ? 50 : 0;
    tierEl.innerHTML =
      '<p class="pk-cart__tier-m">' + msg + '</p>' +
      '<div class="pk-cart__track" role="progressbar" aria-valuemin="1" aria-valuemax="3" aria-valuenow="' + Math.min(n, 3) + '" aria-label="Stack and Save progress">' +
        '<span class="pk-cart__fill" style="width:' + fill + '%"></span>' +
        '<i class="pk-cart__node is-on" style="left:0"></i>' +
        '<i class="pk-cart__node' + (n >= 2 ? ' is-on' : '') + (n === 2 ? ' is-cur' : '') + '" style="left:50%"></i>' +
        '<i class="pk-cart__node' + (n >= 3 ? ' is-on is-cur' : '') + '" style="left:100%"></i>' +
      '</div>' +
      '<div class="pk-cart__marks"><span>1 piece</span><span>2 · ' + T2 + '%</span><span>3+ · ' + T3 + '%</span></div>';
    tierEl.hidden = false;
  }

  function lineHTML(it) {
    var v = (it.variant_title && it.variant_title !== 'Default Title') ? it.variant_title : '';
    var mrp = mrpOf(it), was = '';
    if (mrp > it.final_line_price) {
      var off = Math.round((mrp - it.final_line_price) * 100 / mrp);
      was = '<s>MRP ' + money(mrp) + '</s>' + (off >= 5 ? '<span class="pk-cart__off">' + off + '% off</span>' : '');
    }
    return '<li class="pk-cart__it" data-key="' + esc(it.key) + '">' +
      '<a class="pk-cart__im" href="' + esc(it.url) + '">' + (it.image ? '<img src="' + esc(sized(it.image, 240)) + '" alt="' + esc(it.product_title) + '" width="120" height="150" loading="lazy">' : '') + '</a>' +
      '<div class="pk-cart__it-b">' +
        '<a class="pk-cart__it-t" href="' + esc(it.url) + '">' + esc(short(it.product_title)) + '</a>' +
        (v ? '<span class="pk-cart__it-v">' + esc(v) + '</span>' : '') +
        '<span class="pk-cart__it-p">' + money(it.final_line_price) + was + '</span>' +
        '<div class="pk-cart__it-row">' +
          '<div class="pk-cart__qty" role="group" aria-label="Quantity">' +
            '<button type="button" data-q="' + (it.quantity - 1) + '" aria-label="Decrease quantity">−</button>' +
            '<span aria-live="polite">' + it.quantity + '</span>' +
            '<button type="button" data-q="' + (it.quantity + 1) + '" aria-label="Increase quantity">+</button>' +
          '</div>' +
          '<button type="button" class="pk-cart__rm" data-q="0">Remove</button>' +
        '</div>' +
      '</div></li>';
  }

  function welcomeHTML(n) {
    if (!WON || !WCODE) return '';
    if (pctFor(n) > 0) return '';
    return '<div class="pk-cart__welcome" data-pk-c-welcome>' +
      '<svg class="pk-cart__welcome-ic" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3" aria-hidden="true"><rect x="3.5" y="9" width="17" height="11.5" rx="1"/><path d="M3 9h18M12 9v11.5M12 9c-2-3.5-6-3.5-6-1s4 1 6 1zm0 0c2-3.5 6-3.5 6-1s-4 1-6 1z"/></svg>' +
      '<span class="pk-cart__welcome-tx"><span>New here? <b>' + esc(WTX) + '</b></span><em>Applied at checkout · or stack 2+ pieces to save more</em></span>' +
      '<button type="button" class="pk-cart__welcome-code" data-pk-c-welcome-copy aria-label="Copy code ' + esc(WCODE) + '"><span class="pk-cart__welcome-c">' + esc(WCODE) + '</span><span class="pk-cart__welcome-l" data-l>Copy</span></button>' +
      '</div>';
  }

  function render() {
    var n = cart ? cart.item_count : 0;
    nEl.textContent = '(' + n + ')';
    [].forEach.call(document.querySelectorAll('[data-pk-cart-count]'), function (el) { el.textContent = n; });
    [].forEach.call(document.querySelectorAll('[data-pk-cart-open]'), function (el) { el.setAttribute('aria-label', 'Bag, ' + n + ' item' + (n === 1 ? '' : 's')); });
    if (!n) return renderEmpty();
    renderTier(n);
    var html = '<ul class="pk-cart__list" role="list">' + cart.items.map(lineHTML).join('') + '</ul>';
    var note = cart.note || '';
    html += '<details class="pk-cart__gift"' + (note ? ' open' : '') + '><summary><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3" aria-hidden="true"><rect x="3.5" y="9" width="17" height="11.5" rx="1"/><path d="M3 9h18M12 9v11.5M12 9c-2-3.5-6-3.5-6-1s4 1 6 1zm0 0c2-3.5 6-3.5 6-1s-4 1-6 1z"/></svg><span>Make it a gift <em>· add a note</em></span><i aria-hidden="true"></i></summary>' +
      '<label class="pk-sr" for="pk-c-note">Gift note</label><textarea id="pk-c-note" rows="3" maxlength="300" placeholder="Write a short note. We’ll tuck it in, with prices left off the packing slip." data-pk-c-note>' + esc(note) + '</textarea><span class="pk-cart__saved" data-pk-c-saved hidden>Saved</span></details>';
    html += '<section class="pk-cart__bill" aria-label="Order summary"><p class="pk-cart__bill-h">Order summary</p><dl class="pk-cart__sum is-full" data-pk-c-full></dl><div data-pk-c-you></div>' + (FINE ? '<p class="pk-cart__fine">' + esc(FINE) + '</p>' : '') + welcomeHTML(n) + '</section>';
    html += '<section class="pk-cart__up" data-pk-c-up hidden></section>';
    body.innerHTML = html;
    renderSum(n);
    foot.hidden = false;
    loadUpsell(n);
  }

  function renderSum(n) {
    var sub = cart.items_subtotal_price != null ? cart.items_subtotal_price : cart.total_price;
    var pct = pctFor(n);
    var save = Math.round(cart.total_price * pct / 100);
    var total = cart.total_price - save;
    var mrp = 0;
    cart.items.forEach(function (it) { mrp += mrpOf(it); });
    var mrpOff = Math.max(0, mrp - sub);
    var h = '';
    if (mrpOff > 0) {
      h += '<div class="is-mrp"><dt>MRP</dt><dd>' + money(mrp) + '</dd></div>';
      h += '<div class="is-save"><dt>Discount on MRP</dt><dd>−' + money(mrpOff) + '</dd></div>';
    } else {
      h += '<div><dt>Subtotal</dt><dd>' + money(sub) + '</dd></div>';
    }
    var appl = 0;
    (cart.cart_level_discount_applications || []).forEach(function (d) {
      appl += d.total_allocated_amount;
      h += '<div class="is-save"><dt>' + esc(d.title) + '</dt><dd>−' + money(d.total_allocated_amount) + '</dd></div>';
    });
    if (save > 0) h += '<div class="is-save"><dt>Stack &amp; Save (' + pct + '%)' + (CODE ? '<small>Applied at checkout with ' + esc(CODE) + '</small>' : '') + '</dt><dd>−' + money(save) + '</dd></div>';
    h += '<div class="is-total"><dt>' + (save > 0 ? 'Estimated total' : 'Total') + '<small>Incl. of all taxes · Free shipping</small></dt><dd>' + money(total) + '</dd></div>';
    var full = body.querySelector('[data-pk-c-full]');
    if (full) full.innerHTML = h;
    var you = mrpOff + save + appl;
    if (you > 0) {
      var youPct = mrp > 0 ? Math.round(you * 100 / Math.max(mrp, sub)) : 0;
      youEl.innerHTML = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" aria-hidden="true"><path d="M20 12.5 12.5 20a1.5 1.5 0 0 1-2.1 0L4 13.6V4h9.6l6.4 6.4a1.5 1.5 0 0 1 0 2.1z"/><circle cx="8.5" cy="8.5" r="1.3"/></svg><span>You’re saving <b>' + money(you) + '</b>' + (youPct >= 5 ? ' (' + youPct + '%)' : '') + ' on this order</span>';
      youEl.hidden = false;
    } else youEl.hidden = true;
    var slot = body.querySelector('[data-pk-c-you]');
    if (slot) slot.appendChild(youEl);
    var youPct2 = mrp > 0 ? Math.round(you * 100 / Math.max(mrp, sub)) : 0;
    sumEl.innerHTML = '<div class="is-total"><dt>' + (save > 0 ? 'Estimated total' : 'Total') +
      (you > 0 ? '<small class="is-you">You save ' + money(you) + (youPct2 >= 5 ? ' (' + youPct2 + '%)' : '') + '</small>' : '<small>Incl. of all taxes · Free shipping</small>') +
      '</dt><dd>' + money(total) + '</dd></div>';
    goLbl.textContent = 'Checkout securely · ' + money(total);
  }

  function miniCard(p, label) {
    var v = (p.variants || []).filter(function (x) { return x.available; })[0];
    if (!v) return '';
    var im = (p.featured_image && (p.featured_image.url || p.featured_image)) || (p.images && p.images[0] && (p.images[0].src || p.images[0])) || '';
    if (typeof im === 'object') im = im.src || '';
    var cents = typeof v.price === 'number';
    var now = cents ? v.price : Math.round(parseFloat(v.price) * 100);
    var was = v.compare_at_price ? (cents ? +v.compare_at_price : Math.round(parseFloat(v.compare_at_price) * 100)) : 0;
    var off = was > now ? Math.round((was - now) * 100 / was) : 0;
    var multi = (p.variants || []).length > 1;
    var url = '/products/' + esc(p.handle);
    var btn = multi
      ? '<a class="pk-cart__mc-add" href="' + url + '" aria-label="Choose options for ' + esc(short(p.title)) + '"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M9 6l6 6-6 6"/></svg></a>'
      : '<button type="button" class="pk-cart__mc-add" data-pk-c-add="' + v.id + '" aria-label="Add ' + esc(short(p.title)) + ' to bag"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg></button>';
    return '<li class="pk-cart__mc"><div class="pk-cart__mc-media"><a class="pk-cart__mc-im" href="' + url + '" tabindex="-1">' + (im ? '<img src="' + esc(sized(im, 360)) + '" alt="" loading="lazy" width="180" height="225">' : '') + '</a>' + (off >= 5 ? '<span class="pk-cart__mc-off">' + off + '% off</span>' : '') + btn + '</div>' +
      '<a class="pk-cart__mc-t" href="' + url + '">' + esc(short(p.title)) + '</a>' +
      '<span class="pk-cart__mc-p"><b>' + money(now) + '</b>' + (was > now ? '<s>' + money(was) + '</s>' : '') + '</span>' +
      '</li>';
  }

  function renderEmpty() {
    tierEl.hidden = true;
    foot.hidden = true;
    body.innerHTML = '<div class="pk-cart__empty"><svg width="34" height="34" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" aria-hidden="true"><path d="M5 8h14l-1 12H6z"/><path d="M9 8a3 3 0 0 1 6 0"/></svg>' +
      '<p class="pk-cart__empty-t">Your bag is empty</p><p class="pk-cart__empty-s">Start with the pieces 60,000+ women already live in. Any 2 save ' + T2 + '%, any 3 save ' + T3 + '%.</p>' +
      '<a class="pk-cart__btn" href="' + esc(EMPTY_URL) + '">Shop best sellers</a></div>' +
      '<section class="pk-cart__up is-empty" data-pk-c-up hidden></section>';
    collectionProducts(EMPTY).then(function (ps) {
      var up = body.querySelector('[data-pk-c-up]');
      if (!up || !ps.length) return;
      up.innerHTML = '<div class="pk-cart__up-hd"><p class="pk-cart__up-ey">60,000+ women wear these</p><p class="pk-cart__up-t">Most loved</p></div><ul class="pk-cart__mcs is-grid" role="list">' + ps.slice(0, 4).map(function (p) { return miniCard(p); }).join('') + '</ul>';
      up.hidden = false;
    });
  }

  function collectionProducts(handle) {
    if (!handle) return Promise.resolve([]);
    if (recoCache['c:' + handle]) return Promise.resolve(recoCache['c:' + handle]);
    return json('/collections/' + handle + '/products.json?limit=12').then(function (d) {
      var ps = (d.products || []).filter(function (p) { return (p.variants || []).some(function (v) { return v.available; }); });
      recoCache['c:' + handle] = ps;
      return ps;
    }).catch(function () { return []; });
  }

  function recos(pid) {
    var k = 'r:' + pid;
    if (recoCache[k]) return Promise.resolve(recoCache[k]);
    function get(intent) { return json('/recommendations/products.json?product_id=' + pid + '&limit=8&intent=' + intent).then(function (d) { return d.products || []; }).catch(function () { return []; }); }
    return get('complementary').then(function (a) { return a.length >= 2 ? a : get('related').then(function (b) { return a.concat(b); }); })
      .then(function (ps) { recoCache[k] = ps; return ps; });
  }

  function loadUpsell(n) {
    var up = body.querySelector('[data-pk-c-up]');
    if (!up || !cart.items.length) return;
    var inCart = {};
    cart.items.forEach(function (i) { inCart[i.product_id] = 1; });
    var title = 'Complete the look';
    var eyebrow = n >= 3 ? 'Styled with your picks' : n === 2 ? 'Add a third · save ' + T3 + '% on all' : 'Add a second · save ' + T2 + '% on both';
    recos(cart.items[0].product_id).then(function (ps) {
      ps = ps.filter(function (p) { return !inCart[p.id] && p.available !== false && (p.variants || []).some(function (v) { return v.available; }); });
      if (ps.length < 2) return collectionProducts(UPSELL || EMPTY).then(function (b) { return ps.concat(b.filter(function (p) { return !inCart[p.id]; })); });
      return ps;
    }).then(function (ps) {
      var seen = {};
      ps = ps.filter(function (p) { if (seen[p.id]) return false; seen[p.id] = 1; return true; }).slice(0, 4);
      if (!ps.length || !body.contains(up)) return;
      up.innerHTML = '<div class="pk-cart__up-hd"><p class="pk-cart__up-ey">' + eyebrow + '</p><p class="pk-cart__up-t">' + title + '</p></div><ul class="pk-cart__mcs" role="list">' + ps.map(function (p) { return miniCard(p); }).join('') + '</ul>';
      up.hidden = false;
    });
  }

  /* -------------------------------- actions -------------------------------- */
  function refresh() { return json('/cart.js').then(loadCmp).then(function (c) { cart = c; render(); return c; }).catch(function () {}); }

  function change(key, q, row) {
    if (busy) return;
    busy = true;
    if (row) row.classList.add('is-busy');
    json('/cart/change.js', { method: 'POST', body: JSON.stringify({ id: key, quantity: Math.max(0, q) }) })
      .then(loadCmp)
      .then(function (c) { cart = c; render(); announce(c); })
      .catch(function () { if (row) row.classList.remove('is-busy'); PK.toast && PK.toast('<span>Couldn’t update the bag. Please try again.</span>'); })
      .then(function () { busy = false; });
  }

  function add(id, btn) {
    if (btn) { btn.disabled = true; btn.classList.add('is-busy'); }
    json('/cart/add.js', { method: 'POST', body: JSON.stringify({ items: [{ id: +id, quantity: 1 }] }) })
      .then(function () { return refresh(); })
      .then(function (c) { if (c) announce(c); })
      .catch(function () { if (btn) { btn.disabled = false; btn.classList.remove('is-busy'); } PK.toast && PK.toast('<span>Couldn’t add that piece. Please try again.</span>'); });
  }

  function announce(c) {
    document.dispatchEvent(new CustomEvent('cart:count:update', { detail: { item_count: c.item_count } }));
  }

  body.addEventListener('click', function (e) {
    var q = e.target.closest('[data-q]');
    if (q) { var row = q.closest('[data-key]'); change(row.getAttribute('data-key'), +q.getAttribute('data-q'), row); return; }
    var w = e.target.closest('[data-pk-c-welcome-copy]');
    if (w) {
      var l = w.querySelector('[data-l]');
      var done = function () { if (l) l.textContent = 'Copied'; w.classList.add('is-copied'); setTimeout(function () { if (l) l.textContent = 'Copy'; w.classList.remove('is-copied'); }, 1600); };
      if (navigator.clipboard) navigator.clipboard.writeText(WCODE).then(done, done); else done();
      return;
    }
    var a = e.target.closest('[data-pk-c-add]');
    if (a) { e.preventDefault(); add(a.getAttribute('data-pk-c-add'), a); }
  });
  body.addEventListener('input', function (e) {
    if (!e.target.matches('[data-pk-c-note]')) return;
    clearTimeout(noteTimer);
    var val = e.target.value;
    noteTimer = setTimeout(function () {
      json('/cart/update.js', { method: 'POST', body: JSON.stringify({ note: val }) }).then(function (c) {
        cart.note = c.note;
        var s = body.querySelector('[data-pk-c-saved]');
        if (s) { s.hidden = false; setTimeout(function () { s.hidden = true; }, 1500); }
      }).catch(function () {});
    }, 600);
  });

  /* checkout: close the bag first (dialogs sit above everything), then hand to Fastrr */
  dlg.querySelector('[data-pk-c-checkout]').addEventListener('click', function (e) {
    var ev = e;
    PK.close(dlg, function () {
      if (typeof window.shiprocketCheckoutBuyCartHandler === 'function') {
        try { window.shiprocketCheckoutBuyCartHandler(ev); return; } catch (err) {}
      }
      window.location.href = '/checkout';
    });
  });

  /* ------------------------------ open / close ------------------------------ */
  PK.wire && PK.wire(dlg);
  function open(opener) {
    if (!dlg.open) { PK.open(dlg, opener); }
    refresh();
  }
  window.PKCart = { open: open, refresh: refresh };

  document.addEventListener('click', function (e) {
    var o = e.target.closest && e.target.closest('[data-pk-cart-open],a[href="/cart"],a[href$="/cart"],[aria-controls="CartDrawer"]');
    if (!o || dlg.contains(o)) return;
    e.preventDefault();
    e.stopPropagation();
    open(o);
  }, true);

  /* any successful add-to-bag (theme forms, PDP, quick add, apps) opens the bag */
  var ADD = /\/cart\/add(\.js)?(\?|$)/i, MUT = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/i;
  window.fetch = function (input, init) {
    var url = '';
    try { url = typeof input === 'string' ? input : (input && input.url) || ''; } catch (err) {}
    var p = origFetch(input, init);
    if (MUT.test(url) && !(init && init.__pk)) {
      p.then(function (r) {
        if (!r || !r.ok) return;
        if (ADD.test(url) && !dlg.open) open(); else if (dlg.open) refresh(); else refresh();
      }).catch(function () {});
    }
    return p;
  };
  var xo = XMLHttpRequest.prototype.open, xs = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (m, u) { this.__pkAdd = ADD.test(String(u || '')); return xo.apply(this, arguments); };
  XMLHttpRequest.prototype.send = function () {
    if (this.__pkAdd) this.addEventListener('load', function () { if (this.status >= 200 && this.status < 300) open(); });
    return xs.apply(this, arguments);
  };
  ['cart:update', 'cart:reload', 'cart:refresh'].forEach(function (ev) { document.addEventListener(ev, function () { if (dlg.open) refresh(); }); });

  /* keep Fastrr's overlay on top */
  new MutationObserver(function () { if (dlg.open && document.getElementById('fastrr-main-container')) PK.close(dlg); }).observe(document.body, { childList: true });

  /* deep link: /?bag=open */
  if (/[?&]bag=open/.test(location.search)) open();
  refresh();
})();
